import React, { useEffect, useState } from 'react'
import { Row, Col, Uploader, Icon, Message, Table, ButtonGroup, IconButton } from 'rsuite'
import {
  requiredFiled,
  isValidators,
  isImageOrPdf,
  isValidFileType,
} from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import { isEmpty } from 'lodash-es'

export default function FileListWidget({
  dataTable,
  disabledForm,
  onPreview = () => {},
  onDownload = () => {},
  onDelete = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <>
      {dataTable && dataTable.length > 0 && (
        <Table autoHeight height={300} wordWrap bordered data={dataTable || []}>
          <Column width={90} align="center" fixed>
            <HeaderCell>ไฟล์ที่</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column minWidth={300} flexGrow={1}>
            <HeaderCell>ชื่อไฟล์</HeaderCell>
            <Cell dataKey="label" />
          </Column>

          <Column width={150} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      onClick={(e) => onPreview(rowData)}
                    />
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                      onClick={(e) => onDownload(rowData)}
                    />
                    {!disabledForm && (
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={(e) => onDelete(rowData, index)}
                        disabled={!rowData.enableDelete || rowData.disabled}
                      />
                    )}
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>
      )}
    </>
  )
}
